import { render, staticRenderFns } from "./ReferenciasTable.vue?vue&type=template&id=12284b24&scoped=true"
import script from "./ReferenciasTable.vue?vue&type=script&lang=js"
export * from "./ReferenciasTable.vue?vue&type=script&lang=js"
import style0 from "./ReferenciasTable.vue?vue&type=style&index=0&id=12284b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12284b24",
  null
  
)

export default component.exports